import { render } from "./ProfileHomeSubpage.vue?vue&type=template&id=308ef220&scoped=true"
import script from "./ProfileHomeSubpage.vue?vue&type=script&lang=js"
export * from "./ProfileHomeSubpage.vue?vue&type=script&lang=js"

import "./ProfileHomeSubpage.vue?vue&type=style&index=0&id=308ef220&lang=css"
import "./ProfileHomeSubpage.vue?vue&type=style&index=1&id=308ef220&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308ef220"]])

export default __exports__